<template>
  <van-list
    v-model="loading"
    :finished="finished"
    finished-text="没有更多了"
    @load="onLoad"
  >
		<div class="balance-detail-row title">
			<div class="date">变动时间</div>
			<div class="type">变动类型</div>
			<div class="amt">变动前金额</div>
			<div class="amt">变动金额</div>
			<div class="amt">变动后金额</div>
		</div>
		<div class="balance-detail-row" :class="{'red': item.chgType === 10 || item.chgType === 20 || item.chgType === 21, 'green': item.chgType===30 || item.chgType===40}" v-for="(item, index) in list" :key="index">
			<div class="date">{{item.created}}</div>
			<div class="type">{{item.chgType | chgTypeFilter}}</div>
			<div class="amt">{{(item.currentAmt/100).toFixed(2)}}</div>
			<div class="amt">{{(item.chgAmt/100).toFixed(2)}}</div>
			<div class="amt">{{((item.currentAmt+item.chgAmt)/100).toFixed(2)}}</div>
		</div>
  </van-list>
</template>
<script>
import BalanceApi from '@/api/balance'
import {mapState} from "vuex";
import moment from 'moment'
import wx from "weixin-js-sdk";

const statusMap = {
	10: '充值',
	20: '赠送',
	21: '订单退回',
	30: '消费',
	40: '退费'
} 

export default {
  name: "orderDetail",
  components: {},
	filters: {
		chgTypeFilter(chgType) {
			return statusMap[chgType]
		},
	},
  data() {
    return {
			query: {
			  page: 1,
			  size: 10
			},
			list: [],
			loading: false,
			finished: false,
    }
  },
  computed: {
    ...mapState({
      tokenInfo: "tokenInfo",
    }),
    billDate() {
      if (this.item) {
        return moment(this.item.billFrom).format('YYYY-MM-DD') + '~' + moment(this.item.billTo).format('YYYY-MM-DD')
      }
      return ""
    }
  },
  mounted() {
		this.query = {
			page: 1,
			size: 10
		}
		this.list = []
  },
  destroy() {
  },
  methods: {
		onLoad() {
			BalanceApi.listDetail(this.query).then(res => {
				if (res.ok) {
					this.list.push(...res.data.data)
					if (res.data.data.length != this.query.size) {
						this.finished = true
					}
				} else {
					this.finished = true
				}
				this.loading = false
			})
		}
  }
}
</script>

<style lang="scss" scoped>
.value-class {
  color: #21AEC3;
}
.balance-detail-row {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 750px;
	text-align: center;
	font-size: 26px;
	margin-bottom: 20px;
	&.title {
		color: #333;
	}
	&.red {
		color: red;
	}
	&.green {
		color: green;
	}
	.date, .type, .amt{
		width: 150px;
	}
	.date, .type, .amt{
		width: 150px;
	}
}
</style>
